<template>
  <default-modal :dialog="dialog" :expanded="modalExpanded" @close-dialog="onClose">
    <div id="new-transaction">
      <v-flex xs12 ml-5 mt-4>
        <h6 class="title">{{i18n('Nova Transação')}}</h6>
        <h5>{{i18n(operationLabel)}}</h5>
        <v-flex class="caption" xs12 mt-1 v-if="showSubject && selected_subject">{{subjectLabel}}: {{selected_subject.social_name}}</v-flex>
        <v-flex class="caption" xs12 mt-1 v-if="showToBankAccount">{{i18n('Conta do beneficiário')}}: {{bankAccountTitle(selected_bank_account)}}</v-flex>
        <v-flex class="caption" xs12 mt-1 v-if="isCurrentView('currency_select')">{{i18n('Selecione as moedas da operação')}}</v-flex>
        <v-flex class="caption" xs12 mt-1 v-if="isCurrentView('subject')">{{i18n('Selecione o cliente')}}</v-flex>
        <v-flex class="caption" xs12 mt-1 v-if="isCurrentView('new-person-subject') || isCurrentView('new-company-subject')">{{i18n('Cadastrando o cliente')}}</v-flex>
        <v-flex class="caption" xs12 mt-1 v-if="isCurrentView('bank-account')">{{i18n('Selecione a conta beneficiária')}}</v-flex>
        <v-flex class="caption" xs12 mt-1 v-if="isCurrentView('new-bank-account')">{{i18n('Cadastrando conta beneficiária')}}</v-flex>
        <v-flex class="caption" xs12 mt-1 v-if="isCurrentView('payment')">{{i18n('Selecione a forma de pagamento')}}</v-flex>
        <v-flex class="caption" xs12 mt-1 v-if="isCurrentView('confirmation')">{{i18n('Por favor, confirme antes de avançar')}}</v-flex>
      </v-flex>
      <div class="view" v-if="isCurrentView('operation')">
        <OperationView @handle-event="handleEvent" />
      </div>
      <div class="view" v-if="isCurrentView('currency_select')">
        <CurrencySelectView @handle-event="handleEvent" :subject="selected_subject" :operation="selected_operation"/>
      </div>
      <div class="view" v-if="isCurrentView('subject')">
        <SubjectView @handle-event="handleEvent" :subject="selected_subject" :source_currency="selected_from_currency" :destination_currency="selected_to_currency" :operation="selected_operation" />
      </div>
      <div class="view" v-if="isCurrentView('new-person-subject')">
        <NewSubjectView @handle-event="handleEvent" :isCnpj="false" />
      </div>
      <div class="view" v-if="isCurrentView('new-company-subject')">
        <NewSubjectView @handle-event="handleEvent" :isCnpj="true" />
      </div>
      <div class="view" v-if="isCurrentView('bank-account')">
        <BankAccountView @handle-event="handleEvent" :subject="selected_subject" :operation="selected_operation" :operationFlow="operation_flow" :fromCurrency="selected_from_currency" :toCurrency="selected_to_currency"/>
      </div>
      <div class="view" v-if="isCurrentView('new-bank-account')">
        <NewBankAccountView @handle-event="handleEvent" :subject="selected_subject" :operation="selected_operation" :toCurrency="selected_to_currency"/>
      </div>
      <div class="view" v-if="isCurrentView('payment')">
        <PaymentView @handle-event="handleEvent" :context="{selected_operation, selected_subject, selected_bank_account, selected_from_bank_account, selected_payment_method, selected_value, selected_exchanged_value, reverse_exchange, selected_from_currency, selected_to_currency, operation_flow}" />
      </div>
      <div class="view" v-if="isCurrentView('confirmation')">
        <ConfirmationView @handle-event="handleEvent" :context="{selected_operation, selected_subject, selected_bank_account, selected_from_bank_account, selected_value, selected_exchanged_value, reverse_exchange, selected_payment_method, selected_from_currency, selected_to_currency, exchange_under_request}" />
      </div>
    </div>
  </default-modal>
</template>

<script>
import DefaultRightModal from './DefaultRightModal'
import OperationView from './NewTransaction/OperationView'
import CurrencySelectView from './NewTransaction/CurrencySelectView'
import Operation from '../controllers/NewTransaction/Operation'
import SubjectView from './NewTransaction/SubjectView'
import BankAccountView from './NewTransaction/BankAccountView'
import NewSubjectView from './NewTransaction/NewSubjectView'
import NewBankAccountView from './NewTransaction/NewBankAccountView'
import PaymentView from './NewTransaction/PaymentView'
import ConfirmationView from './NewTransaction/ConfirmationView'
import utils from '../shared/Utils'


export default {
  name: 'NewTransactionDialog',
  components: {
    'default-modal': DefaultRightModal,
    OperationView,
    CurrencySelectView,
    SubjectView,
    NewSubjectView,
    BankAccountView,
    NewBankAccountView,
    PaymentView,
    ConfirmationView
  },
  props: {
    dialog: {
      type: Boolean
    }
  },
  data(vm) {
    return {
      transaction_controller: new Operation(vm),
      modalExpanded: false,
      selected_operation: null,
      operation_flow: 'both',
      selected_subject: null,
      selected_bank_account: null,
      selected_from_bank_account: null,
      selected_value: 0.0,
      selected_exchanged_value: 0.0,
      reverse_exchange: false,
      selected_payment_method: null,
      selected_from_currency: null,
      selected_to_currency: null,
      exchange_under_request: false,
    }
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    },
    handleEvent(event) {
      this.transaction_controller.handle(event)
    },
    isCurrentView(view) {
      if(view === this.transaction_controller.name()) {
        return true
      }
      return false
    },
    onClose() {
      this.transaction_controller = new Operation(this)
      this.modalExpanded = false
      this.selected_operation = null
      this.selected_subject = null
      this.selected_bank_account = null
      this.selected_from_bank_account = null
      this.selected_value = 0.0
      this.selected_payment_method = null
      this.selected_from_currency = null
      this.selected_to_currency = null
      this.showButtons = true
      this.$emit('close-dialog')
    },
    bankAccountTitle(bank_account) {
      return utils.longAccountName(bank_account)
    }
  },
  computed: {
    showOperation() {
      if (this.isCurrentView('operation')){
        return false
      }
      return true
    },
    showSubject() {
      if (['receive', 'pay'].includes(this.selected_operation) &&
           (this.isCurrentView('bank-account') ||
            this.isCurrentView('payment') || this.isCurrentView('subject')  )) {
        return true
      }
      return false
    },
    showToBankAccount() {
      if (['receive', 'pay'].includes(this.selected_operation) &&
            (this.isCurrentView('payment'))) {
        return true
      }
      return false
    },
    subjectLabel() {
      if (this.selected_operation == 'receive') {
        return this.i18n('Cliente pagador')
      }
      if (this.selected_operation == 'pay') {
        return this.i18n('Cliente beneficiado')
      }
      return this.i18n('Cliente')
    },
    operationLabel() {
      switch (this.selected_operation) {
        case 'receive':
          return 'Cobrar do cliente'
        case 'pay':
          return 'Pagar o cliente'
        case 'deposit':
          return 'Depósito em conta interna'
        case 'withdrawal_internal':
          return 'Retirada de conta interna'
        case 'exchange_internal':
          return 'Conversão entre contas internas'
        case 'fee_payoff':
          return 'Pagamento de taxas'
        default:
          return 'Selecione a operação';
      }
    }
  }
}
</script>

<style>

#new-transaction .view {
  min-height: 400px;
}

#new-transaction .buttons-container {
  display: flex;
  justify-content: center;
  border-top: 1px solid rgba(188, 193, 209, 0.33);
  margin-left: 55px;
  margin-right: 55px;
  padding-top: 20px;
  margin-top: 20px;
}

#new-transaction h5 {
  font-size: 18px;
  padding-top: 12px;
}

</style>



// WEBPACK FOOTER //
// src/components/NewTransactionDialog.vue